'use strict';

exports.__esModule = true;
var KEY_PREFIX = exports.KEY_PREFIX = 'persist:';
var FLUSH = exports.FLUSH = 'persist/FLUSH';
var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';
var PAUSE = exports.PAUSE = 'persist/PAUSE';
var PERSIST = exports.PERSIST = 'persist/PERSIST';
var PURGE = exports.PURGE = 'persist/PURGE';
var REGISTER = exports.REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = exports.DEFAULT_VERSION = -1;


//////////////////
// WEBPACK FOOTER
// ./~/redux-persist/lib/constants.js
// module id = 757
// module chunks = 0